export default
    {
        // url: this.$store.state.http.medicamentos.YYYY,
        guardaMedicamento: "/medicamentos/guardaMedicamento",
        guardaReceta: "/medicamentos/guardaReceta",
        guardaRegistrosTh: "/medicamentos/guardaRegistrosTh",
        listRecetas: "/medicamentos/listRecetas",
        listRegistrosTh: "/medicamentos/listRegistrosTh",
        borraRegistrosTh: "/medicamentos/borraRegistrosTh",
        listMedicamentos: "/medicamentos/listMedicamentos",
        listMedAb: "/medicamentos/listMedAb",
    }
